import apis from "./index";
export const revokeToken = async (token) => {
  try {
    const result = await apis.post(
      "/revoke-token",
      {},
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return result;
  } catch (error) {
    throw error.response ? error.response.data : error;
  }
};
